module.exports = __webpack_public_path__ + "img/orange_045.d3a45388.png";